import { render, staticRenderFns } from "./agreement-page.vue?vue&type=template&id=2b703e45"
import script from "./agreement-page.vue?vue&type=script&lang=js"
export * from "./agreement-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports